// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ranking-item[data-v-f70a64a0]{align-items:center;display:flex;width:100%}@media(max-width:985px){.ranking-item[data-v-f70a64a0]{gap:12px}}@media(min-width:986px){.ranking-item[data-v-f70a64a0]{gap:24px}}.ranking-item__contents[data-v-f70a64a0]{display:flex;flex-direction:column;flex-grow:1;gap:8px;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
